import styled from 'styled-components';
import { Icon } from '../../../../Icons';
import { Button as UIButton } from '../../../../Button/styled';
const CLOSE_RIGHT_MOBILE = 60;
const CLOSE_TOP = 24;
export const Button = styled(UIButton) `
    background: none;
    border: none;
    cursor: pointer;
    right: ${CLOSE_RIGHT_MOBILE}px;
    top: ${CLOSE_TOP}px;
    position: absolute;
    z-index: 4;
`;
export const StyledIcon = styled(Icon) `
    position: relative;
    width: 48px;
    height: 48px;
`;
//# sourceMappingURL=index.js.map